import { useEffect, useRef, useState } from 'react';
import useSessionManager from './useSessionManager';

export default () => {
  const sessionManager = useSessionManager();
  const sessionManagerRef = useRef(sessionManager);
  const [hasSessionError, setHasSessionError] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    sessionManagerRef.current = sessionManager;
  });

  useEffect(() => {
    const { current: currentSessionManager } = sessionManagerRef;

    const handleSessionError = errorData => {
      setHasSessionError(true);
      setError(errorData);
    };

    if (currentSessionManager) {
      currentSessionManager.registerErrorHandler(handleSessionError);
    }

    return () => {
      if (currentSessionManager) {
        currentSessionManager.unregisterErrorHandler(handleSessionError);
      }
    };
  }, []);

  return [hasSessionError, error];
};
